// path: src/pages/IPA/Negociacoes/pages/NegociacaoFornecedor/components/GridErrorState/GridErrorState.tsx
import classNames from 'classnames';
import { ButtonPrimary } from '../../../../../../../components/ButtonPrimary';
import styles from './GridErrorState.module.scss';

export interface IGridErrorState {
  /**
   * A nova busca da consulta que falhou. O bloco não sabe qual consulta é, não sabe se ela está em
   * andamento e não guarda estado algum sobre isso: quem decide se ele continua na tela é a grade,
   * pelo estado da consulta.
   */
  onRetry: () => void;
  className?: string;
}

/** O bloco que a grade mostra na área do corpo da tabela quando a carga dos produtos falha. */
export const GridErrorState = ({ onRetry, className }: IGridErrorState) => (
  <div className={classNames(styles['grid-error-state'], className)} role="alert">
    <h3>Não foi possível carregar os produtos</h3>
    <p>Tente novamente para recuperar os dados da rede.</p>
    {/* A chamada é envolvida numa seta porque a nova busca da consulta aceita um objeto de opções:
        passar o `onClick` direto entregaria o evento de clique como primeiro argumento. */}
    <ButtonPrimary type="button" theme="ghost" onClick={() => onRetry()}>
      Tentar novamente
    </ButtonPrimary>
  </div>
);
